import classNames from "classnames";
import style from "./account.module.scss";
import packageJson from '../../../package.json';
const version = packageJson.version;
const Logout = () => {

  //todo: logout function
  
  return (
    <div className={style.logout}>
     <button className={style.logoutButton}>Logout</button>
     <p className={style.version}>v&nbsp;{version}</p>
    </div>
    
  );
};

export default Logout;
